import React, { useContext } from 'react';
import { Avatar, Box, createStyles, makeStyles } from '@material-ui/core';
import { OnboardingPageLayout } from '../OnboardingPageLayout';
import { GraySmall } from '../../../theme/colors';
import BaseTypography from '../../Text/BaseTypography';
import {
  MfaFormProps,
  OnboardingForgotPasswordForm,
} from '../OnboardingForms/OnboardingForgotPasswordForm';
import { OnboardingAuthLayoutProps } from './OnboardingAuthLayout';
import { OnboardingFormCard } from '../OnboardingFormCard';
import { FlagsContext } from '../../../context';

const useStyles = makeStyles(() =>
  createStyles({
    logo: {
      width: '100px',
      height: '100px',
      margin: 'auto',
    },
    subTitleText: {
      color: GraySmall,
    },
  }),
);

type OnboardingForgotPasswordPageProps = OnboardingAuthLayoutProps &
  MfaFormProps;

export const OnboardingForgotPasswordPage = ({
  onAuthComplete,
  onMfaRequired,
}: OnboardingForgotPasswordPageProps) => {
  const classes = useStyles();
  const { GoogleLoginForInternalUser } = useContext(FlagsContext);
  const Container = GoogleLoginForInternalUser
    ? OnboardingFormCard
    : OnboardingPageLayout;
  return (
    <Container>
      <Box mt={2} mb={3.75}>
        <Avatar
          alt="Portal Technologies"
          src="/images/copilot-logo.svg"
          className={classes.logo}
        />
      </Box>
      <Box mt={2} mb={6.25} textAlign="center" px={{ xs: 2, sm: 0 }}>
        <BaseTypography fontType="24Medium">Reset your password</BaseTypography>
      </Box>
      <Box mb={{ xs: 0, sm: 2 }}>
        <OnboardingForgotPasswordForm
          onAuthComplete={onAuthComplete}
          onMfaRequired={onMfaRequired}
        />
      </Box>
    </Container>
  );
};
